if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      this.productElement = null;
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');

      // Add loading indicator
      const dtLoader = document.createElement('div');
      dtLoader.className = 'dT_loading';
      dtLoader.innerHTML = `<div class="loading"></div>`;

      setTimeout(() => {
        $('.quick-add-modal[open]').find('.main-product_info').addClass('quick-add-modal-in-progress');
      }, 100);
      setTimeout(() => {
        $('.main-product_info').removeClass('quick-add-modal-in-progress');
      }, 200);

      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // Fetch product HTML from the product URL
      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          console.log(responseHTML);
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');

          if (!this.productElement) {
            console.warn('productElement not found in fetched HTML');
            return;
          }

          this.safePreventDuplicatedIDs();

          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.preventVariantURLSwitching();

          super.show(opener);
        })
        .catch((error) => {
          console.error('Quick Add modal load error:', error);
          this.modalContent.innerHTML = `<p>Failed to load product.</p>`;
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
      // Re-run all scripts in the injected HTML
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attr => {
          newScriptTag.setAttribute(attr.name, attr.value);
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios, variant-selects');
      if (!variantPicker) return;
      variantPicker.setAttribute('data-update-url', 'false');

      // Your custom color swatch click styling
      $('input:radio[name="Color"]').click(function() {
        $('input:radio[name="Color"]').next('.swatch-element').removeClass('clicked');
        $(this).next('.swatch-element').addClass('clicked');
      });
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const productEnquiry = this.productElement.querySelector('enquiryPopUp');
      if (productEnquiry) productEnquiry.remove();

      const modals = this.productElement.querySelectorAll('modal-dialog');
      modals.forEach((modal) => modal.remove());
    }

    async safePreventDuplicatedIDs() {
      // Wait up to 500ms for productElement if not ready
      for (let i = 0; i < 10; i++) {
        if (this.productElement) break;
        await new Promise(r => setTimeout(r, 50));
      }

      if (!this.productElement) {
        console.warn('⏳ productElement not found after waiting, skipping preventDuplicatedIDs()');
        return;
      }

      const sectionId = this.productElement.dataset.section;
      if (!sectionId) {
        console.warn('⚠️ Section ID missing from productElement');
        return;
      }

      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
        sectionId,
        `quickadd-${sectionId}`
      );

      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });

      console.info(`✅ preventDuplicatedIDs completed for section: ${sectionId}`);
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (galleryList) {
        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
      }

      // Remove FBT (bundle selector)
      const FBT = this.modalContent.querySelector('[id^="dT_bundleSelector"]');
      if (FBT) FBT.remove();

      // Remove tabs under product info (to simplify modal view)
      const Tabs = this.modalContent.querySelector('[class^="product__info-as-bottom-tabs"]');
      if (Tabs) Tabs.remove();
    }
  });
}
